import Modal from "../Modal";
import RenewalOfferForm from "../../forms/opportunity/RenewalOfferForm";
import {useState} from "react";
import { useTranslation } from "../../../hooks/useTranslation";

export default function RenewalOfferModal({show, handleClose, renewal, title}) {
    const { t } = useTranslation();
    return (
        <Modal title={title} show={show} handleClose={handleClose} width="800px">
            <RenewalOfferForm handleClose={handleClose} renewal={renewal}/>
        </Modal>
    );
};